import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import SEO from "@/components/SEO";

export default function OrderSuccess() {
    const { orderNumber } = useParams();
    return (
        <>
            <SEO title="অর্ডার সফল" description={`Order #${orderNumber} placed successfully`} />
            <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
            <CheckCircle2 className="w-20 h-20 mx-auto text-green-600" />
            <h1 className="text-3xl md:text-4xl font-bold text-brand-navy mt-6">অর্ডার সফল!</h1>
            <p className="text-brand-navy/65 mt-2">আপনার অর্ডার সফলভাবে গৃহীত হয়েছে। আমরা শীঘ্রই কনফার্ম করার জন্য আপনাকে কল করব।</p>
            <div className="mt-8 glass rounded-2xl p-6">
                <div className="text-sm text-brand-navy/60">আপনার অর্ডার নম্বর</div>
                <div className="text-3xl font-bold text-brand-royal mt-1 font-en tracking-wider" data-testid="order-number-display">{orderNumber}</div>
                <div className="text-xs text-brand-navy/55 mt-3">এই নম্বরটি সংরক্ষণ করুন — পরবর্তীতে অর্ডার ট্র্যাকিং এর জন্য প্রয়োজন হবে।</div>
            </div>
            <div className="mt-8 flex justify-center gap-3">
                <Link to="/track" className="btn-primary px-5 py-2.5 rounded-xl font-medium">অর্ডার ট্র্যাক করুন</Link>
                <Link to="/" className="px-5 py-2.5 rounded-xl border border-brand-light hover:bg-brand-light/30">হোমে ফিরুন</Link>
            </div>
        </div>
        </>
    );
}
